// extracted by mini-css-extract-plugin
module.exports = {"HeroesMaintain":"HeroesMaintain__HeroesMaintain__3LwWl"};